import { render, staticRenderFns } from "./HeaderGlobal.vue?vue&type=template&id=4b49fc37&scoped=true&"
import script from "./HeaderGlobal.vue?vue&type=script&lang=js&"
export * from "./HeaderGlobal.vue?vue&type=script&lang=js&"
import style0 from "./HeaderGlobal.vue?vue&type=style&index=0&id=4b49fc37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b49fc37",
  null
  
)

export default component.exports